module.exports = __webpack_public_path__ + "static/img/xian.2a9231f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xian.png
// module id = M/26
// module chunks = 0